export const objectKeysSpecific = <Type extends {}>(o: Type): (keyof Type)[] =>
    Object.keys(o) as any
